<template>
<modal :show="show" @close="close">
    <div @click.stop.prevent class="modal-header">
        <h5 class="modal-title">Error </h5>
        <button @click.stop="close" type="button" class="close">
            <i class="icon icon-close"></i>
        </button>
    </div>
    <div @click.stop.prevent class="modal-body">
		<p>{{errorMessage}}</p>
    </div>
</modal>
</template>

<script>
import Modal from "@/components/general/ErrorModalBase";
import { mapGetters } from 'vuex';
export default {

    name: 'EnterprisePreviewModal',

    components: {
        Modal
    },

    data() {
        return {
            show: false
        }
    },

    methods: {
        open() {
            this.show = true;
        },

        close() {
            this.show = false;
            this.$emit('close');
			this.$store.dispatch("clearErrorMessage");
        },

        confirm() {
            this.show = false;
            this.$emit('confirm');
        }
    },

	watch:{
		errorMessage(value){
			if(value&&value!=""){
				this.open();
			}
		}
	},

	computed:{
		...mapGetters(["errorMessage"])
	}

}
</script>

